import { render, staticRenderFns } from "./CropperModal.vue?vue&type=template&id=2bedd05e&scoped=true&"
import script from "./CropperModal.vue?vue&type=script&lang=js&"
export * from "./CropperModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedd05e",
  null
  
)

export default component.exports